import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { helpers } from '@bingads-webui/projection-grid-toolbar';
import { OverridableToolbarView } from '@bingads-webui/toolbar';
import HotelOptionsBase from '../assignment-utils/hotel-options-base';

const edm = globalContext.requireDefault('campaignui/feature/hotel-center-edm/index');
const state = globalContext.require('component/state/index');
const jsdata = globalContext.require('campaignui/feature/hotel-center-js-data/index');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');
const i18n = globalContext.require('component/i18n/loader!campaignui/feature/hotel-center');

export default class HotelOutGroupOptions extends HotelOptionsBase {
  constructor({
    onSearchInvoked,
    excludeGroupId,
    perfMarker,
    appConfig,
    isUINext = false,
  }) {
    super();

    this.name = 'HotelsOutGroupGrid';
    const AssociationEntity = jsdata.HotelAssociation;

    this.dataSource = {
      entity: jsdata.HotelAssociation,
      type: 'js-data',
      options: {
        cacheResponse: false,
        path: 'Travel/V1/',
        url: '/Customers(:advertisercustomer_id)/Accounts(:account_id)/Associations',
      },
    };

    if (isUINext) {
      this.scrolling.viewport = $('.hotel-associations__container');
    }

    this.filterToolbar = new OverridableToolbarView({
      toolbarId: _.uniqueId('grid-toolbar-'),
      items: [{
        type: 'search-box',
        id: 'hotel-out-search-filter',
        placeholder: i18n.getString('HotelCenter_Group_Search_Label'),
        onChange: searchTerm => onSearchInvoked(searchTerm),
      },
      ],
    }).render();

    $('.hotel-out-group__container .toolbar-container').append(this.filterToolbar.$el);

    // Empty default toolbar is still needed for dependency
    const gridToolbar = helpers.singleToolbar({
      items: [
        {
          type: 'selector',
          id: 'quick-filter',
        },
      ],
    });

    this.plugins.toolbar = gridToolbar;

    this.schema = AssociationEntity.schema;

    this.plugins.quickFilter = {
      items: [{
        key: 'exist',
        value: {
          query: {
            HotelGroupId: { $ne: excludeGroupId },
          },
        },
      }],
    };

    this.plugins.dateFilter = {
      isOdataActionSource: false,
      edm,
      state,
      addDateChangeListener: _.noop,
    };

    this.plugins.perfMarker = {
      marker: perfMarker,
      appConfig,
    };

    this.columns = [
      bingadsGridColumn({
        name: 'PartnerHotelId',
        title: 'HotelCenter_Overview_Grid_Hotel_Advertiser_Hotel_ID_Label',
        sortable: true,
        filterable: true,
        type: 'string',
        bodyClasses: ['truncated'],
        helpId: 'pop_BA_HotelAds_PartnerHotelID',
        i18n: this.i18n,
      }), bingadsGridColumn({
        name: 'HotelName',
        sortable: 'HotelName',
        type: 'string',
        bodyClasses: ['truncated'],
        title: this.i18n.getString('HotelCenter_Group_Hotel_Name_Label'),
      }), bingadsGridColumn({
        name: 'HotelGroupName',
        sortable: 'HotelGroupName',
        type: 'string',
        bodyClasses: ['truncated'],
        title: i18n.getString('HotelCenter_Group_Name_Label'),
      }), bingadsGridColumn({
        name: 'SubAccountName',
        sortable: 'SubAccountName',
        type: 'string',
        bodyClasses: ['truncated'],
        title: this.i18n.getString('HotelCenter_Group_SubAccount_Name_Label'),
      })];
  }
}
